//@ts-check
import isRelative from './isRelative';
import stripDesignTrunkFromPath from './stripDesignTrunkFromPath';
import getFolderPath from './getFolderPath';
/**
 * @type {import("./types").relativeType}
 */

export default (function (absolutePath, basePath) {
  if (!basePath) return absolutePath;
  if (!absolutePath) return absolutePath;
  if (isRelative(absolutePath)) return absolutePath;
  var absoluteParts = stripDesignTrunkFromPath(absolutePath).split('/');
  var baseParts = stripDesignTrunkFromPath(getFolderPath(basePath)).split('/'); //remove identical prefixes

  while (true) {
    if (!absoluteParts[0]) {
      break;
    } else if (absoluteParts[0] === baseParts[0]) {
      absoluteParts.shift();
      baseParts.shift();
    } else {
      break;
    }
  }

  var relativePath = '';

  if (baseParts.length) {
    relativePath = baseParts.map(function (p) {
      return '..';
    }).join('/') + '/' + absoluteParts.join('/');
  } else {
    relativePath = './' + absoluteParts.join('/');
  }

  return relativePath;
});